import project01 from './../img/projects/01.jpg';
import project01Big from './../img/projects/01-big.jpg';
import project02 from './../img/projects/02.jpg';
import project02Big from './../img/projects/02-big.jpg';
import project03 from './../img/projects/03.jpg';
import project03Big from './../img/projects/03-big.jpg';
import project04 from './../img/projects/04.jpg';
import project04Big from './../img/projects/04-big.jpg';
import project05 from './../img/projects/05.jpg';
import project05Big from './../img/projects/05-big.jpg';
import project06 from './../img/projects/06.jpg';
import project06Big from './../img/projects/06-big.jpg';

const projects = [
    {
        title: 'Zaputopia',
        skills: 'Next.JS, Tailwind, nextTheme, nextAuth, MongoDB, custom Hook, jest',
        img: project04,
        imgBig: project04Big,
        link: 'https://project-zaputopia.vercel.app/',
    },
    {
        title: 'Local school site',
        skills: 'React, React Router Dom, Tailwind, Adaptive, Leaflet',
        img: project05,
        imgBig: project05Big,
        link: 'https://school295.netlify.app/',
    },
    {
        title: 'Weather App',
        skills: 'React, Typescript, Tailwind, Weather API, Images for big Cities',
        img: project01,
        imgBig: project01Big,
        link: 'https://antons-weather-v2.netlify.app/',
    },
    {
        title: 'User modal window',
        skills: 'React, TypeScript, dummyJSON, modal window',
        img: project02,
        imgBig: project02Big,
        link: 'https://funny-paprenjak-3c2b41.netlify.app/',
    },
    {
        title: 'Tasks',
        skills: 'React, Materialize-css, TypeScript, UUID',
        img: project03,
        imgBig: project03Big,
        link: 'https://pet-notes-tsreact.netlify.app/',
    },
    {
        title: 'SmartSpace ',
        skills: 'HTML, CSS, JavaScript',
        img: project06,
        imgBig: project06Big,
        link: 'https://adaptive-smartspace.netlify.app/',
    },
];
export {projects}